import React from 'react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300 py-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center mb-8">
          <div>
            <h3 className="text-white font-bold text-lg mb-2">Julianne Lee</h3>
            <p className="text-sm">Frontend Engineer & AI Enthusiast</p>
          </div>
          <div className="mt-4 md:mt-0">
            <div className="flex gap-6 justify-center md:justify-end">
              <a href="https://github.com/juliannehalversen" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-400 transition">
                GitHub
              </a>
              <a href="https://www.linkedin.com/in/julianne-lee-6b2b94177/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-400 transition">
                LinkedIn
              </a>
              <a href="https://medium.com/@juliannevlee" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-400 transition">
                Medium
              </a>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-700 pt-8 text-center md:text-right">
          <p className="text-sm">
            Built with React & Tailwind CSS
          </p>
          <p className="text-sm mt-2">© {currentYear} Julianne Lee. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
